import { DialogContent } from '@mui/material';
import React from 'react';

interface IProps {
    children: React.ReactNode;
}

export const PublicationDialogContent: React.FC<IProps> = ({ children  }) => {
    return (
        <DialogContent sx={{ display: "flex", flexDirection: "column", flex: "1 1 auto", maxHeight: "100%" }}>
            {children}
        </DialogContent>
    );
};